import React, { memo } from 'react'
import { Typography } from 'transfix-ui/core'
import { IVersion } from 'types/logs'
import { capitalize } from 'utils/capitalize'

interface IEventCellProps {
  version: IVersion
  condensed: boolean
}

export const EventCell = memo<IEventCellProps>(({ condensed, version }) => (
  <div>
    {condensed && (
      <Typography color='textSecondary' variant='caption'>
        #{version.id}
      </Typography>
    )}
    <Typography variant='body2'>
      {capitalize(version.event)} {version.className} {!condensed && `#${version.id}`}
    </Typography>
  </div>
))
